import React from "react";

import { Tooltip } from "@material-ui/core";
import AcceptedIcon from "@material-ui/icons/CheckCircleOutline";
import AcceptedStoredIcon from "@material-ui/icons/OfflinePinOutlined";
import RejectedIcon from "@material-ui/icons/HighlightOff";
import { green, red } from "@material-ui/core/colors";

import { BlankIcon, RemoveIcon } from "../../../components/common/iconography";
import { ShipmentLineItemStatus } from "../../../utils/constants";

export const OutboundStatusIcon = ({ record, ...props }) => {
  if (!record) return null;
  return record.status === ShipmentLineItemStatus.LOADED ? (
    <Tooltip title="Loaded" placement="right" arrow>
      <RemoveIcon style={{ color: green[700] }} />
    </Tooltip>
  ) : record.status === ShipmentLineItemStatus.VERIFIED ? (
    <Tooltip title="Completed" placement="right" arrow>
      <AcceptedIcon style={{ color: green[600] }} />
    </Tooltip>
  ) : record.status === ShipmentLineItemStatus.REJECTED ? (
    <Tooltip title="Rejected" placement="right" arrow>
      <RejectedIcon style={{ color: red[700] }} />
    </Tooltip>
  ) : record.status === ShipmentLineItemStatus.SHIPPED ? (
    <Tooltip title="Shipped" placement="right" arrow>
      <AcceptedStoredIcon style={{ color: green[600] }} />
    </Tooltip>
  ) : (
    // record.state === ShipmentLineItemStatus.PENDING ? (
    <Tooltip title="Pending" placement="right" arrow>
      <BlankIcon style={{ color: green[700] }} />
    </Tooltip>
  );
};
